import React from 'react';
import { actions as notificationsActions } from 'features/notifications/index';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useNotifications = () => {
  const dispatch = useDispatch();
  const { notificationsVisible, notifications } = useSelector(state => state.notifications);
  const [activeItem, setActiveItem] = useState(null);

  const handleToggleVisible = () => {
    dispatch(notificationsActions.changeVisibilityOfNotifications());
  };

  const handleHideNotification = (id) => {
    dispatch(notificationsActions.setNotificationClosed(id));
  };

  const hideList = activeItem !== null && !notificationsVisible;

  return {
    hideList,
    activeItem,
    setActiveItem,
    notifications,
    notificationsVisible,
    handleHideNotification,
    handleToggleVisible
  }
}

export default useNotifications;